export default __webpack_public_path__ + "static/media/bihorel15.06af097b.jpg";